import styled from 'styled-components';

const InfoStyle = styled.div`
	overflow: hidden;
	color: var(--neutral1000);

	.wrapper-draggable {
		margin-bottom: var(--sectionDistance);
	}

	.wrapper-container {
		display: flex;
		justify-content: space-between;
		padding: 0 var(--contPaddingLR);
		padding-top: var(--distanceHero);
	}

	.wrapper-image-title {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: var(--sp1x);

		.text-title {
			color: inherit;
			transition: color var(--trTime) ease-in;
			white-space: nowrap;
		}

		img {
			object-fit: contain;
		}

		.image-wrapper-icon {
			--proportion: var(--iconSizeHero);
			width: var(--iconSizeHero);
			opacity: 0;

			/* font-size: var(--iconSizeHero); */
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		.wrapper-container {
			gap: var(--sp2x);
			min-width: 100vw;
			width: fit-content;
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceHero: var(--sp2x);

		.wrapper-draggable {
			margin-bottom: calc(var(--sectionDistance) + var(--sp0-5x));
		}

		.wrapper-image-title {
			gap: var(--sp0-5x);
		}
	}
`;
export default InfoStyle;
